/**
 * Block is used on
 *
 * @returns {{init(): void, canShowMore: boolean, changeCategory(): void, load(): void, pagesMax: number, showMore(): void, page: number, term_id: number, loading: boolean, posts: []}}
 */
export default () => ({
    posts: [],
    loading: true,
    page: 1,
    pagesMax: 0,
    canShowMore: false,
    term_id: 0,
    category_id: 0,
    searchQuery: '',

    init() {
        const searchParams = new URLSearchParams(window.location.search);
        let term_id = window.hch_initial_location_id
            || (searchParams.get('location_id') || 0);
        let category_id = window.hch_initial_category_id
            || (searchParams.get('category_id') || 0);
        const categorySlug = (searchParams.get('category') || '').trim();

        if (category_id <= 0 && categorySlug.length > 0) {
            const categorySelect = document.getElementById('category');

            if (categorySelect) {
                const matchedOption = Array.from(categorySelect.options)
                    .find((option) => option.dataset.slug === categorySlug);

                if (matchedOption) {
                    category_id = matchedOption.value;
                }
            }
        }

        this.searchQuery = (searchParams.get('search') || '').trim();

        if (term_id > 0) {
            this.term_id = term_id;
        }

        if (category_id > 0) {
            this.category_id = category_id;
        }

        this.load();
    },

    clear() {
        this.searchQuery = '';
        this.syncUrl();
        this.search();
    },

    search() {
        this.syncUrl();
        this.page = 1;
        this.loading = true;
        this.posts = [];
        this.load();
    },

    load() {
        let ref = this;

        fetch(hch_theme_ajax_endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            },
            body: 'action=hch_fetch_posts&post_type=event&event_home_id=' + this.term_id + '&term_id=' + this.category_id + '&category=event_category&query=' + this.searchQuery,
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                data.data.results.forEach(function (p, index) {
                    ref.posts.push({
                        'id': p.id,
                        'title': p.title,
                        'permalink': p.permalink,
                        'excerpt': p.excerpt,
                        'image': p.image,
                        'date_short': p.date_short,
                        'date_formatted': p.date_formatted,
                        'event_location': p.event_location,
                        'event_date': p.event_date
                    });
                });

                this.loading = false;
                this.page++;
                this.pagesMax = data.data.max_num_pages
                this.canShowMore = (this.pagesMax >= this.page);
            })
            .catch((error) => {
                console.error(error);
            });

    },

    getSelectedCategorySlug() {
        const categorySelect = document.getElementById('category');

        if (!categorySelect) {
            return '';
        }

        const selectedOption = categorySelect.options[categorySelect.selectedIndex];

        if (!selectedOption) {
            return '';
        }

        return (selectedOption.dataset.slug || '').trim();
    },

    syncUrl() {
        const url = new URL(window.location.href);
        const params = url.searchParams;
        const locationId = parseInt(this.term_id, 10) || 0;
        const categoryId = parseInt(this.category_id, 10) || 0;
        const categorySlug = this.getSelectedCategorySlug();

        if (locationId > 0) {
            params.set('location_id', locationId);
        } else {
            params.delete('location_id');
        }

        if (categoryId > 0) {
            if (categorySlug.length > 0) {
                params.set('category', categorySlug);
                params.delete('category_id');
            } else {
                params.set('category_id', categoryId);
                params.delete('category');
            }
        } else {
            params.delete('category_id');
            params.delete('category');
        }

        if (this.searchQuery && this.searchQuery.trim().length > 0) {
            params.set('search', this.searchQuery.trim());
        } else {
            params.delete('search');
        }

        window.history.replaceState({}, '', `${url.pathname}${params.toString() ? '?' + params.toString() : ''}`);
    },

    changeCategory() {
        this.syncUrl();
        this.loading = true;
        this.posts = [];
        this.load();
    },

    changeEventCategory() {
        this.syncUrl();
        this.loading = true;
        this.posts = [];
        this.load();
    },

    showMore() {
        let ref = this;
        this.loading = true;

        fetch(hch_theme_ajax_endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            },
            body: 'action=hch_fetch_posts&post_type=event&event_home_id=' + this.term_id + '&term_id=' + this.category_id + '&category=event_category&query=' + this.searchQuery + '&page=' + this.page
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                data.data.results.forEach(function (p, index) {
                    ref.posts.push({
                        'id': p.id,
                        'title': p.title,
                        'permalink': p.permalink,
                        'excerpt': p.excerpt,
                        'image': p.image,
                        'date_short': p.date_short,
                        'date_formatted': p.date_formatted,
                        'event_location': p.event_location,
                        'event_date': p.event_date
                    });
                });

                this.loading = false;
                this.page++;
                this.pagesMax = data.data.max_num_pages
                this.canShowMore = (this.pagesMax >= this.page);

                let scrollPos = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;

                window.scrollTo({
                    top: scrollPos + 400,
                    behavior: 'smooth'
                });
            })
            .catch((error) => {
                console.error(error);
            });
    }
})